const routes = {
  createSystemSettings: '/system-settings',
  getSystemSettings: '/system-settings',
  getActiveSystemSettings: '/system-settings/active',
  updateSystemSettings: '/system-settings/',
  deleteSystemSettings: '/system-settings/',
};

export default routes;